var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7096_51863)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.875 6.66975V20.3377C0.875 22.2211 2.41141 23.7575 4.29474 23.7575H15.3414C17.2248 23.7575 18.7612 22.2211 18.7612 20.3377V18.124C18.7612 17.7495 18.4583 17.4466 18.0839 17.4466C17.7094 17.4466 17.4065 17.7495 17.4065 18.124V20.3377C17.4065 21.4776 16.4759 22.4083 15.3359 22.4083H4.29474C3.15483 22.4083 2.22417 21.4776 2.22417 20.3377V6.66975C2.22417 5.52983 3.15483 4.59917 4.29474 4.59917H15.3414C16.4814 4.59917 17.412 5.52983 17.412 6.66975V8.88349C17.412 9.25796 17.7149 9.56084 18.0894 9.56084C18.4638 9.56084 18.7667 9.25796 18.7667 8.88349V6.66975C18.7667 4.78641 17.2303 3.25 15.347 3.25H4.29474C2.41141 3.25 0.875 4.7809 0.875 6.66975Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0981 18.5945C22.2303 18.7267 22.401 18.7928 22.5772 18.7928C22.7534 18.7928 22.9241 18.7267 23.0563 18.5945L27.6765 13.9743C27.9409 13.71 27.9409 13.2859 27.6765 13.0216L23.0563 8.40137C22.792 8.13704 22.3679 8.13704 22.1036 8.40137C21.8393 8.6657 21.8393 9.08973 22.1036 9.35405L25.5729 12.8234H12.9127C12.5382 12.8234 12.2354 13.1262 12.2354 13.5007C12.2354 13.8752 12.5382 14.178 12.9127 14.178H25.5674L22.0981 17.6473C21.8338 17.9062 21.8338 18.3357 22.0981 18.5945Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7096_51863"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white",
    transform: "translate(0.875)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.090a21a86e73cb7870dc62f74b128594.svg";
export { ForwardRef as ReactComponent };